/* Warum PDP gallery + swatch handler. Vanilla, no framework. */
class WarumPdp extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.thumbs = Array.from(this.querySelectorAll('[data-warum-thumb]'));
    this.slides = Array.from(this.querySelectorAll('[data-warum-slide]'));
    this.counter = this.querySelector('[data-warum-counter]');
    this.totalCount = this.querySelectorAll('[data-warum-slide]:not([data-warum-slide-video])').length;

    this.thumbs.forEach((t, i) => {
      t.addEventListener('click', () => this.activate(i));
    });

    this.swatches = Array.from(this.querySelectorAll('[data-warum-swatch]'));
    this.swatches.forEach((s) => {
      s.addEventListener('click', (e) => {
        if (s.classList.contains('disabled')) {
          e.preventDefault();
          return;
        }
        this.selectVariant(s);
      });
    });
  }
  activate(i) {
    this.thumbs.forEach((t, j) => t.classList.toggle('active', i === j));
    this.slides.forEach((s, j) => s.classList.toggle('active', i === j));
    if (this.counter) {
      const slide = this.slides[i];
      const isVideo = slide && slide.hasAttribute('data-warum-slide-video');
      if (isVideo) {
        this.counter.textContent = 'Video';
      } else {
        // count which non-video slide this is
        let imgIndex = 0;
        for (let k = 0; k <= i; k++) {
          if (!this.slides[k].hasAttribute('data-warum-slide-video')) imgIndex++;
        }
        this.counter.textContent = `${imgIndex} / ${this.totalCount}`;
      }
    }
  }
  selectVariant(swatch) {
    const variantId = swatch.getAttribute('data-warum-variant-id');
    const url = swatch.getAttribute('data-warum-variant-url');
    if (url) {
      window.location.href = url;
      return;
    }
    if (variantId) {
      const url2 = new URL(window.location.href);
      url2.searchParams.set('variant', variantId);
      window.location.href = url2.toString();
    }
  }
}
customElements.define('warum-pdp', WarumPdp);
